"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserWorkspacePermissions = void 0;
var sdk_ui_1 = require("@gooddata/sdk-ui");
var dataLoaders_1 = require("../../../dataLoaders");
var utils_1 = require("../utils");
/**
 * Hook allowing to download user workspace permissions
 * @param config - configuration of the hook
 * @internal
 */
function useUserWorkspacePermissions(_a) {
    var backend = _a.backend, onCancel = _a.onCancel, onError = _a.onError, onLoading = _a.onLoading, onPending = _a.onPending, onSuccess = _a.onSuccess, workspace = _a.workspace;
    var effectiveBackend = sdk_ui_1.useBackend(backend);
    var effectiveWorkspace = sdk_ui_1.useWorkspace(workspace);
    utils_1.backendInvariant(effectiveBackend, "useUserWorkspacePermissions");
    utils_1.workspaceInvariant(effectiveWorkspace, "useUserWorkspacePermissions");
    var loader = dataLoaders_1.userWorkspacePermissionsDataLoaderFactory.forWorkspace(effectiveWorkspace);
    var promise = function () { return loader.getUserWorkspacePermissions(effectiveBackend); };
    return sdk_ui_1.useCancelablePromise({ promise: promise, onCancel: onCancel, onError: onError, onLoading: onLoading, onPending: onPending, onSuccess: onSuccess }, [
        effectiveBackend,
        effectiveWorkspace,
    ]);
}
exports.useUserWorkspacePermissions = useUserWorkspacePermissions;
//# sourceMappingURL=useUserWorkspacePermissions.js.map